export default __webpack_public_path__ + "static/Druid-0227eeec32622c80a14b11cd4fdea9ad.png";